import { BadgeCheck, MinusCircle, Clock } from "lucide-react";

export function HadafBadge({ support }) {
  if (!support || support.status === "not_applicable") return null;
  const yes = support.status === "supported", no = support.status === "unsupported";
  const Icon = yes ? BadgeCheck : no ? MinusCircle : Clock;
  const label = yes ? "مدعومة من هدف" : no ? "غير مدرجة في هدف" : "دعم هدف: قيد التحقق";
  return <span className={`inline-flex items-center gap-1 text-xs rounded-full px-2 py-1 border ${yes ? "text-ok bg-ok/10 border-ok/25" : "text-ink-2 border-line"}`}
    title={support.note || label} data-testid="hadaf-status"><Icon size={13} />{label}</span>;
}
